import React from "react";
import { CollapsePanel } from "./CollapsePanel";
import { DetailGrid, DetailGridItem } from "./DetailGrid";

export const InsuranceInfo = ({ insuranceInfo, isPharmacyOwnedByClinic, type = "primary" }) => {
  const labelText = type === "secondary" ? "Secondary Insurance Info" : "Primary Insurance Info";
  const insuranceType = `${type}-insurance`;

  return (
    <>
      <CollapsePanel labelText={labelText} className="detail-grid-large" id={`${insuranceType}-panel`}>
        <DetailGrid className="detail-grid-large" id={`${insuranceType}-grid`}>
          <DetailGridItem id={`${insuranceType}-verified-name`} title="Verified Insurance Name" value={insuranceInfo?.verifiedName} />
          <DetailGridItem id={`${insuranceType}-effective-date`} title="Policy Effective Date" value={insuranceInfo?.effectiveDate} />
          <DetailGridItem id={`${insuranceType}-employer-name`} title="Employer Name" value={insuranceInfo?.employerName} />
          <DetailGridItem id={`${insuranceType}-provided-name`} title="Provided Insurance Name" value={insuranceInfo?.name} />
          <DetailGridItem id={`${insuranceType}-policy-end-date`} title="Policy End Date" value={insuranceInfo?.policyEndDate} />
          <DetailGridItem id={`${insuranceType}-funding-type`} title="Funding Type" value={insuranceInfo?.fundingType} />
          <DetailGridItem id={`${insuranceType}-member-id`} title="Member Id" value={insuranceInfo?.memberId} />
          <DetailGridItem id={`${insuranceType}-payor-phone`} title="Payor Phone" value={insuranceInfo?.payorPhone} />
          <DetailGridItem id={`${insuranceType}-benefits-verified`} title="Benefits Verified" value={insuranceInfo?.benefitsVerified} />
          <DetailGridItem id={`${insuranceType}-group-id`} title="Group Id" value={insuranceInfo?.groupId} />
          <DetailGridItem id={`${insuranceType}-plan-name`} title="Plan Name" value={insuranceInfo?.planName} />
          <DetailGridItem id={`${insuranceType}-date-verified`} title="Date Verified" value={insuranceInfo?.dateVerified} />
          <DetailGridItem id={`${insuranceType}-active-coverage`} title="Active Coverage" value={insuranceInfo?.activeCoverage} />
          <DetailGridItem id={`${insuranceType}-plan-type`} title="Plan Type" value={insuranceInfo?.planType} />
          {isPharmacyOwnedByClinic && (
            <DetailGridItem
              id={`${insuranceType}-subscriber-relationship`}
              title="Subscriber Relationship"
              value={insuranceInfo?.subscriberRelationship}
            />
          )}
        </DetailGrid>
      </CollapsePanel>
    </>
  );
};
